import React from "react";
import Sale from "../../../../../utilities/data/model/Sale";
import SaleItem from "../../../../../utilities/data/model/SaleItem";
import Customer from "../../../../../utilities/data/model/Customer";

export type CartContextType = {
  navigation: any;
  disabled: boolean;
  totalItems: number;
  sale: Sale;
  items: SaleItem[];
  totals: {
    totalPrice: number;
    totalBasePrice: number;
    totalTax: number;
    totalDiscount: number;
  };
  balance: number;
  handleOnClearCart: () => void;
  handleOnEditCustomer: (customer: Customer) => Promise<void>;
};

export const CartContext = React.createContext<CartContextType | undefined>(
  undefined
);
